import React, { useState, Fragment, Component } from 'react'
import TeamBloc from "../Blocs/TeamBloc"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { cancelToken } from "../../../../../services/adapters/master/penialian360Service"
import apiResponse from '../../../../../services/apiResponse'
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import CustomSelect from "../../../../../helpers/ui/CustomSelect"
import FeatherIcon from "feather-icons-react";
import moment from "moment"
import { Redirect } from "react-router-dom"
import 'moment/locale/id'
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import {
    InputGroup,
    CardHeader,
    Table,
    Badge,
    InputGroupText,
    FormGroup,
    Input,
    Alert,
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Tooltip,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Spinner
} from "reactstrap"
import * as XLSX from 'xlsx'; 

class MemberComponent extends Component 
{
    teamBloc = new TeamBloc();

    source
    historyTable = 'member360Active'
    defaultOrder = 'ms360_team_member_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
 

    constructor(props) {
        super(props)
        this.state = {
            percentageStatus: 0.0,
            modalConfirmDeleteAll: false,
            loadingDeleteAll: false,
            modalTambah: false,
            loadingTambah: false,
            can_import: false,
            bulkInsert: [],
            loadingBulk: false,
            modalUpload: false,
            loadingUpload: false,
            messageUpload: "",
            messageFailed: "Data gagal disimpan",
            configForm: {
                ms360_team_sampling_sejawat: 0,
                ms360_team_sampling_junior: 0,
                ms360_team_priority_ahli_madya: 0,
                ms360_team_priority_ahli_muda: 0
            },
            loadingDownload: false,
            canGenerate: false,
            groups: [],
            modalConfig: false,
            loadingConfig: false,
            relationSelected: '',
            evaluatorUuid: '',
            evaluateeUuid: '',
            loadingGroupMember: false,
            loadingGenerate: false,
            modalGenerate: false,
            filterData: 'all',
            team: {},
            loadingLeader: false,
            redirectBack: false,
            period_uuid: "",
            evalutees: [],
            members: [],
            leaders: [],
            organizations: [],
            organizationLoading: false,
            organizationUUid: '',
            loadingContent: true,
            progressContent: 0.0,
            periodUuid: "",
            inactiveUuid: "",
            dataForm: {},
            obj: null,
            modalShow: false,
            modalToggle: false,
            tooltip: false,  
            detailUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }

        this.fileInputRef = React.createRef();
        this.toggleMandatory = this.toggleMandatory.bind(this);
        this.handlePeerChange = this.handlePeerChange.bind(this);
        this.handleJuniorChange = this.handleJuniorChange.bind(this);
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const queryParams = new URLSearchParams(window.location.search);
        const uuid = queryParams.get('uuid')
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            team_uuid: uuid,
            filter: this.state.filterData
        }
        await this.teamBloc.fetchMembers(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault();
        var userdata = JSON.parse(localStorage.getItem("userdata"));
        var create_uuid = userdata.employee_uuid;
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true,
        });
    };

     confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    clampPercent(val) {
        if (Number.isNaN(val)) return 0;
        return Math.min(100, Math.max(0, val));
    }

    toggleMandatory(key) {
        if (key === "ahliMadya") {
            this.setState({
                configForm: {
                ...this.state.configForm,
                ms360_team_priority_ahli_madya:
                    this.state.configForm.ms360_team_priority_ahli_madya === 1 ? 0 : 1,
                },
            });
        } else {
            this.setState({
                configForm: {
                ...this.state.configForm,
                ms360_team_priority_ahli_muda:
                    this.state.configForm.ms360_team_priority_ahli_muda === 1 ? 0 : 1,
                },
            });
        }
    }


    handlePeerChange(e) {
        const val = this.clampPercent(parseInt(e.target.value, 10));
        this.setState({
            configForm: {
                ...this.state.configForm,
                ms360_team_sampling_sejawat: parseFloat(val)
            },
        });
    }

    handleJuniorChange(e) {
        const val = this.clampPercent(parseInt(e.target.value, 10));
        this.setState({
            configForm: {
                ...this.state.configForm,
                ms360_team_sampling_junior: parseFloat(val)
            },
        });
    }


    handleUnitKerja = async (work_unit_uuid) => {
        this.setState({ organizationUUid: work_unit_uuid })
        const queryParams = new URLSearchParams(window.location.search);
        const team_uuid = queryParams.get('uuid')
        const params = {
            employee_uuid: '',
            work_unit_uuid: work_unit_uuid,
            relation: this.state.relationSelected,
            team_uuid: team_uuid
        }
        await this.teamBloc.fetchGroupMember(params)
    }

    getRows() {
        return [
            {
                label: "JPT Pratama (Kabiro/Direktur)",
                atasan: "JPT Madya / Deputi",
                sejawat: `Sesama JPT Pratama`,
                bawahan: `+ Staff (${this.state.configForm.ms360_team_sampling_junior}% Sampling)`,
            },
            {
                label: "Fungsional Ahli Madya",
                atasan: "JPT Pratama",
                sejawat: `Sesama Fungsional & Pelaksana`,
                bawahan: `+ Staff ((${this.state.configForm.ms360_team_sampling_junior}% Sampling)`,
            },
            {
                label: "Fungsional Ahli Muda & Pertama",
                atasan: "JPT Pratama",
                sejawat: `Sesama Fungsional & Pelaksana`,
                bawahan: `Staff Pelaksana ((${this.state.configForm.ms360_team_sampling_junior}% Sampling)`,
            },
            {
                label: "Jabatan Pelaksana / Staff",
                atasan: "JPT Pratama",
                sejawat: `Sesama Fungsional & Pelaksana`,
                bawahan: "",
            },
        ];
    }
   
    componentDidMount() {

        this.loadContent()
        this.loadOrganization()

        this.teamBloc.timkerjaDetailTeamChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingContent: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingContent: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const team = response?.team ?? {};
                    const conf = {
                        ms360_team_sampling_sejawat:
                            Number(team.ms360_team_sampling_sejawat) || 30,

                        ms360_team_sampling_junior:
                            Number(team.ms360_team_sampling_junior) || 20,

                        ms360_team_priority_ahli_madya:
                            Number(team.ms360_team_priority_ahli_madya) || 0,

                        ms360_team_priority_ahli_muda:
                            Number(team.ms360_team_priority_ahli_muda) || 0,
                    };


                    this.setState({
                        team: response.team,
                        members: response.members,
                        loadingContent: false,
                        evaluatorUuid: '',
                        relationSelected: '',
                        configForm: conf,
                        groups: response.groups,
                        canGenerate: response.can_generate,
                        organizations: response.organizations,
                        organizationUUid: response.team?.ms360_team_work_unit_uuid
                    })
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaMembersChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

         this.teamBloc.timkerjaUnitKerjaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        organizationLoading: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        organizationLoading: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                       organizations: response.organizations,
                       organizationLoading: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaTemplateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    document.body.style.cursor = 'wait';
                    break
                case apiResponse.LOADING:
                    document.body.style.cursor = 'wait';
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.buildTemplate(response.employees)
                    document.body.style.cursor = 'default';
                    break
                case apiResponse.ERROR:
                    document.body.style.cursor = 'default';
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaMemberCreateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const status = result.data.status
                    this.setState({
                        failed: status === false,
                        loading: false,
                        success: status,
                        modalShow: false,
                        modalToggle: false,
                        evaluatorUuid: '',
                        relationSelected: '',
                        messageFailed: status ? '' : response?.message
                    });
                    if(status){
                        this.setTokenAPI()
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaConfigUpdateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingConfig: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingConfig: true
                    })
                    break
                case apiResponse.COMPLETED:
                    this.setState({
                        loadingConfig: false,
                        modalConfig: false,
                        evaluatorUuid: '',
                        relationSelected: ''
                    });
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loadingConfig: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaDeleteMemberChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const status = result.data.status
                    this.setState({
                        failed: status === false,
                        loading: false,
                        success: true,
                        modalShow: false,
                        modalToggle: false,
                        inactiveUuid: '',
                        obj: null,
                        messageFailed: status ? '' : response?.message
                    });
                    if(status){
                        this.setTokenAPI()
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaGenerateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingGenerate: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingGenerate: true
                    })
                    break
                case apiResponse.COMPLETED:
                    setTimeout(() => { 
                        this.setState({
                            loadingGenerate: false,
                            modalGenerate: false,
                            percentageStatus: 0.00
                        });
                        this.setTokenAPI()
                     }, 750)
                    break
                case apiResponse.ERROR:
                    this.setState({
                        modalGenerate: false,
                        loadingGenerate: false,
                        loading: false,
                        failed: true,
                        percentageStatus: 0.00
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaImportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingUpload: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingUpload: true
                    })
                    break
                case apiResponse.COMPLETED:
                    this.setState({
                        loadingUpload: false,
                        modalUpload: false,
                        bulkInsert: []
                    });
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        bulkInsert: [],
                        modalUpload: false,
                        loadingUpload: false,
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

         this.teamBloc.timkerjaGroupMemberChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingGroupMember: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingGroupMember: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const evalutees = response.items

                    if(evalutees.length === 0){
                         this.setState({
                            loadingGroupMember: false,
                            evalutees: [{
                                value: this.state.obj?.ms360_team_member_evalutaee_uuid,
                                label: this.state.obj?.ms360_team_member_evalutaee_name
                            }]
                        });
                    }else{
                         this.setState({
                            loadingGroupMember: false,
                            evalutees: evalutees
                        });
                    }

                   
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaDownloadChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingDownload: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingDownload: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        loadingDownload: false
                    });
                    this.exportExcel(response)
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loadingDownload: false,
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaSyncChannel.subscribe((result) => {
           switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingBulk: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingBulk: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        loadingBulk: false,
                        bulkInsert: response.result,
                        can_import: response.can_import
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loadingBulk: false,
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaDeleteAllChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingDeleteAll: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingDeleteAll: true
                    })
                    break
                case apiResponse.COMPLETED:
                    this.setState({
                        loadingDeleteAll: false,
                        modalConfirmDeleteAll: false
                    });
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        modalConfirmDeleteAll: false,
                        loadingDeleteAll: false,
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
        
    
    }

    columns = [
        {
            key: "ms360_team_member_evaluator_name",
            text: "PENILAI EVALUATOR",
            className: "ms360_team_member_evaluator_name",
            sortable: true,
            cell: record => {
                return (
                    <Fragment>
                        <span className='d-block'>
                            <strong>
                                <small>{record?.ms360_team_member_evaluator_name}</small>
                            </strong>
                        </span>
                        <p className='d-block'>
                            {record?.ms360_team_member_evaluator_position}<small className='text-muted'> Lv.({record?.ms360_team_member_evaluator_level})</small>
                        </p>
                    </Fragment>
                )
            }
        },
        {
            key: "ms360_team_member_evalutaee_name",
            text: "YANG DINILAI (EVALUATEE)",
            className: "ms360_team_member_evalutaee_name",
            sortable: true,
            cell: record => {
                return (
                    <Fragment>
                        <span className='d-block'>
                            <strong>
                                <small>{record?.ms360_team_member_evalutaee_name}</small>
                            </strong>
                        </span>
                        <p className='d-block'>
                            {record?.ms360_team_member_evalutaee_position} <small className='text-muted'> Lv.({record?.ms360_team_member_evaluatee_level})</small>
                        </p>
                    </Fragment>
                )
            }
        },
        {
            key: "ms360_team_member_relation",
            text: "RELASI PENILAI",
            className: "ms360_team_member_relation",
            sortable: true,
            align: 'center',
            cell: record => {
                const relasi = record.ms360_team_member_relation;
                if(relasi === 'atasan'){
                    return (<span className="badge bg-primary">Atasan</span>)
                }else if(relasi === 'sejawat'){
                    return (<span className="badge bg-success">Sejawat</span>)
                }else{
                    return (<span className="badge bg-warning">Bawahan</span>)
                }
            }
        },
        {
            key: "action",
            text: "AKSI",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.ms360_team_member_uuid;
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"update-" + thisId}
                                onClick={async () => {
                                    this.setState({
                                        organizationUUid: record?.evaluatee_work_unit_uuid,
                                        modalShow: true,
                                        obj: record,
                                        updateUuid: thisId
                                    })
                                    const params = {
                                        team_uuid: record?.ms360_team_member_team_uuid,
                                        organizationUUid: record?.evaluatee_work_unit_uuid,
                                        employee_uuid: record?.ms360_team_member_evaluator_uuid,
                                        work_unit_uuid: record?.evaluatee_work_unit_uuid,
                                        relation: record?.ms360_team_member_relation
                                    }
                                    await this.teamBloc.fetchGroupMember(params)
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-pen"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["update" + thisId] : !this.state["update" + thisId]
                                    })
                                }}
                            >Perbaharui</Tooltip>
                        </span>
                        <span>
                            <button 
                                className="btn btn-danger btn-sm" 
                                id={"delete-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        inactiveUuid: record.ms360_team_member_uuid,
                                        confirm: true
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-trash-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["delete" + thisId] : !this.state["delete" + thisId]
                                    })
                                }}
                            >Hapus</Tooltip>
                        </span>
                    </Fragment>
                )
            }
        }
    ]

    loadContent = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const uuid = queryParams.get('uuid')
        await this.teamBloc.fetchDetailTeam({ uuid: uuid })
    }

    loadOrganization = async() => {
        const queryParams = new URLSearchParams(window.location.search);
        const uuid = queryParams.get('uuid')
        await this.teamBloc.fetchUnitKerja({ uuid: uuid })
    }   
    
    submitData = async () => {
         if(this.state.inactiveUuid !== undefined && this.state.inactiveUuid !== null && this.state.inactiveUuid !== ''){
            await this.teamBloc.fetchTeamDeleteMember({ uuid: this.state.inactiveUuid })
        }else{
            
            const dataForm = this.state.dataForm;
            const formData = new FormData();

            if(this.state.obj !== undefined && this.state.obj !== null){
                formData.append("uuid", this.state.obj.ms360_team_member_uuid ?? "");
            }

            formData.append("team_uuid", this.state.team?.ms360_team_uuid ?? "");
            formData.append("evaluator_uuid", dataForm.evaluator_uuid ?? "");
            formData.append("evalutaee_uuid", dataForm.evalutaee_uuid ?? "");
            formData.append("relation", dataForm.relation ?? "");

            await this.teamBloc.fetchMemberCreate(formData)
        }
    };

    componentWillUnmount(){
        this.teamBloc.timkerjaDetailTeamChannel.unsubscribe()
        this.teamBloc.timkerjaMembersChannel.unsubscribe()
        this.teamBloc.timkerjaMemberCreateChannel.unsubscribe()
        this.teamBloc.timkerjaDeleteMemberChannel.unsubscribe()
        this.teamBloc.timkerjaGenerateChannel.unsubscribe()
        this.teamBloc.timkerjaGroupMemberChannel.unsubscribe()
        this.teamBloc.timkerjaConfigUpdateChannel.unsubscribe()
        this.teamBloc.timkerjaSyncChannel.unsubscribe()
        this.teamBloc.timkerjaImportChannel.unsubscribe()
        this.teamBloc.timkerjaTemplateChannel.unsubscribe()
        this.teamBloc.timkerjaUnitKerjaChannel.unsubscribe()
        this.teamBloc.timkerjaDeleteAllChannel.unsubscribe()
    }

    handleFilter = (fltr) => {
        this.setState({ 
            filterData: fltr
         })
        setTimeout(() => {
            this.setTokenAPI()
        }, 500);
        // const filter = {
        //     filter_value: "",
        //     page_number: 1,
        //     page_size: 10,
        //     sort_order: {
        //         column: "ms360_team_member_evaluator_name",
        //         order: "asc"
        //     }
        // }
        // this.setState({
        //     filterData: fltr,
        //     loadingTable: true,
        //     filter: filter
        // }, function () {
        //     this.setTokenAPI()
        // });
    }

    handleResetAll = async () => {
        const formData = new FormData();
       formData.append("uuid", this.state.team?.ms360_team_uuid);
       await this.teamBloc.fetchDeleteAll(formData)
    }

    // handleGenerate = async () => {
    //    const formData = new FormData();
    //    formData.append("uuid", this.state.team?.ms360_team_uuid);
    //    await this.teamBloc.fetchGenerate(formData)
    // }

    handleGenerate = async () => {
        

        const setProgress = (value) => {
            this.setState({ percentageStatus: value })
        };

        setProgress(20);

        // Let browser render 20%
        await new Promise(resolve => requestAnimationFrame(resolve));

        let progress = 20;

        // Simulated progress while API is running
        const interval = setInterval(() => {
            if (progress < 95) {
                progress += 1;
                setProgress(progress);
            }
        }, 200);

        try {
            
            const formData = new FormData();
            formData.append("uuid", this.state.team?.ms360_team_uuid);
            await this.teamBloc.fetchGenerate(formData);

            // API completed
            clearInterval(interval);

            setProgress(99);

            await new Promise(resolve => setTimeout(resolve, 300));

            setProgress(100);

        } catch (error) {
            clearInterval(interval);

            console.error(error);

            throw error;
        }
    };

    handleChangeMember = async(relation) => {
        this.setState({
            relationSelected: relation, 
            evaluateeUuid: '',  
            evalutees: [],
            obj: {
                ...this.state.obj,
                ms360_team_member_relation: relation
            }
        })
        const queryParams = new URLSearchParams(window.location.search);
        const team_uuid = queryParams.get('uuid')
        const params = {
            team_uuid: team_uuid,
            employee_uuid: this.state.evaluatorUuid,
            work_unit_uuid: this.state.organizationUUid,
            relation: relation
        }
        await this.teamBloc.fetchGroupMember(params)
    }

    handleChangeEvaluator = async(uuid) => {
        this.setState({ evaluatorUuid: uuid })
        const queryParams = new URLSearchParams(window.location.search);
        const team_uuid = queryParams.get('uuid')
        const params = {
            team_uuid: team_uuid,
            employee_uuid: uuid,
            work_unit_uuid: this.state.organizationUUid,
            relation: this.state.relationSelected
        }
        await this.teamBloc.fetchGroupMember(params)
    }

    handleChangeEvaluatee = (uuid) => {
        this.setState({ evaluateeUuid: uuid })
    }

    handleConfig = async () => {
        const frmConfig = new FormData();
        frmConfig.append("uuid", this.state.team?.ms360_team_uuid)
        frmConfig.append("ms360_team_sampling_sejawat", this.state.configForm.ms360_team_sampling_sejawat ?? 30)
        frmConfig.append("ms360_team_sampling_junior", this.state.configForm.ms360_team_sampling_junior ?? 20)
        frmConfig.append("ms360_team_priority_ahli_madya", this.state.configForm.ms360_team_priority_ahli_madya ?? 0)
        frmConfig.append("ms360_team_priority_ahli_muda", this.state.configForm.ms360_team_priority_ahli_muda ?? 0)
        await this.teamBloc.fetchConfigUpdate(frmConfig)
    }

    handleDownload = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const uuid = queryParams.get('uuid')
        await this.teamBloc.fetchDownload({ team_uuid: uuid })
    }

    buildSheet = (aoa) => {
        const worksheet = XLSX.utils.aoa_to_sheet(aoa);

        const colCount = aoa[0].length;

        worksheet["!cols"] = Array.from(
            { length: colCount },
            (_, colIndex) => {
                const maxLength = Math.max(
                    ...aoa.map((row) => {
                        const value = row[colIndex];
                        return value == null ? 0 : String(value).length;
                    })
                );

                return {
                    wch: maxLength + 2,
                };
            }
        );

        // Header style
        for (let colIndex = 0; colIndex < colCount; colIndex++) {
            const cellRef = XLSX.utils.encode_cell({
                r: 0,
                c: colIndex,
            });

            if (worksheet[cellRef]) {
                worksheet[cellRef].s = {
                    fill: {
                        patternType: "solid",
                        fgColor: { rgb: "111111" }
                    }
                };
            }
        }

        return worksheet;
    };

    exportExcel = (items) => {

        const atasan = items.atasan
        const bawahan = items.bawahan
        const sejawat = items.sejawat
        const all = items.semua

       

        const headers = [
            "Penilai (Evaluator)",
            "Yang Dinilai (Evaluatee)",
            "Relasi Peran"
        ];

        const headers2 = [
            "Penilai (Evaluator)",
            "Yang Dinilai (Evaluatee)"
        ];

        const ucfirst = (str) => {
            if (!str) return str;
            return str.charAt(0).toUpperCase() + str.slice(1);
        };

        const dataAll = all.map((r) => [
           r.ms360_team_member_evaluator_name,
           r.ms360_team_member_evalutaee_name,
           ucfirst(r.ms360_team_member_relation)
        ]);

        const dataAtasan = atasan.map((r) => [
           r.ms360_team_member_evaluator_name,
           r.ms360_team_member_evalutaee_name
        ]);

        const dataBawahan = bawahan.map((r) => [
           r.ms360_team_member_evaluator_name,
           r.ms360_team_member_evalutaee_name
        ]);

        const dataSejawat = sejawat.map((r) => [
           r.ms360_team_member_evaluator_name,
           r.ms360_team_member_evalutaee_name
        ]);

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            this.buildSheet([headers, ...dataAll]),
            "Semua"
        );

        XLSX.utils.book_append_sheet(
            workbook,
            this.buildSheet([headers2, ...dataAtasan]),
            "Atasan"
        );

        XLSX.utils.book_append_sheet(
            workbook,
            this.buildSheet([headers2, ...dataSejawat]),
            "Sejawat"
        );

        XLSX.utils.book_append_sheet(
            workbook,
            this.buildSheet([headers2, ...dataBawahan]),
            "Bawahan"
        );

        const now = new Date();
        const pad = (n) => String(n).padStart(2, "0");
        const timestamp =
            `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_` +
            `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

        XLSX.writeFile(workbook, `mapping_peserta_360_${timestamp}.xlsx`);
    }

     handleExcelFileChange = async(e) => {

        const file = e.target.files[0];
        if (!file) return;

        // Validasi extension
        const allowedExtensions = ['xlsx', 'xls'];
        const extension = file.name.split('.').pop().toLowerCase();

        if (!allowedExtensions.includes(extension)) {
            this.setState({
                excelError: 'Format file harus Excel (.xlsx atau .xls)',
                excelFile: null,
                excelFileName: ''
            });
            return;
        }

        const buffer = await file.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array" });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // header: 1 → array-of-arrays, so row 0 is the header row itself
        const rows = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            defval: "",
            blankrows: false,
        });

        const dataRows = rows.slice(1); // skip header row
        const queryParams = new URLSearchParams(window.location.search);
        const uuid = queryParams.get('uuid')

        const items = dataRows.map((row) => ({
            evaluator: String(row[0] ?? "").trim(),
            evaluatee: String(row[1] ?? "").trim(),
            relation: String(row[2] ?? "").trim(),
        }));

        await this.teamBloc.fetchSync({ items: items, team_uuid: uuid })

    };

    templateUpload = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const team_uuid = queryParams.get('uuid')
        await this.teamBloc.fetchTemplate({ uuid: team_uuid })
    }

    buildTemplate = (employees) => {

        const headers = [
            "NIP Evaluator (Penilai)",
            "NIP Evaluatee (Yang Dinilai)",
            "Relasi Penilai",
        ];

      
        const data = [headers];
        const worksheet = XLSX.utils.aoa_to_sheet(data);

        worksheet["!cols"] = [
            { wch: 30 },
            { wch: 30 },
            { wch: 30 },
        ];


        /*
        * ============================================================
        * RELASI
        * ============================================================
        */

        const worksheet2 = XLSX.utils.aoa_to_sheet([
            ["Jenis Relasi"],
            ["Atasan"],
            ["Sejawat"],
            ["Bawahan"]
        ]);

        worksheet2["!cols"] = [
            { wch: 30 }
        ];

        worksheet2["!protect"] = {
            selectLockedCells: false,
            selectUnlockedCells: false
        };


        /*
        * ============================================================
        * REF PEGAWAI
        * ============================================================
        */

        const headersEmployees = [
            "NIP",
            "NAMA PEGAWAI",
            "UNIT KERJA"
        ];

        const dataEmployees = employees.map((r) => [
            r.employee_nip,
            r.employee_name,
            r.work_unit_name
        ]);

        const worksheet3 = XLSX.utils.aoa_to_sheet([
            headersEmployees,
            ...dataEmployees
        ]);

        worksheet3["!cols"] = [
            { wch: 30 },
            { wch: 30 },
            { wch: 50 }
        ];

        worksheet3["!protect"] = {
            selectLockedCells: false,
            selectUnlockedCells: false
        };


        /*
        * ============================================================
        * WORKBOOK
        * ============================================================
        */

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Template Upload Tim Kerja"
        );

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet2,
            "Relasi"
        );

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet3,
            "Ref Pegawai"
        );


        /*
        * ============================================================
        * FILE NAME
        * ============================================================
        */

        const now = new Date();

        const pad = (n) => String(n).padStart(2, "0");

        const timestamp =
            `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_` +
            `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

        XLSX.writeFile(
            workbook,
            `template_tim_kerja_${timestamp}.xlsx`
        );
    };


    doImport = async () => {
       const formData = {
            team_uuid: this.state.team?.ms360_team_uuid,
            items: this.state.bulkInsert
       } 
       await this.teamBloc.fetchImport(formData)
    }

    render(){
        const UNIT_THRESHOLD = 30;
        const groups = this.getRows()
        return (
            <Fragment>
                { this.state.loadingContent ? <>
                    <div className='card'>
                        <div className='card-body p-5 text-center'>
                            <Spinner size="sm" className="me-1" />
                            Memuat Data...
                        </div>
                    </div>
                </> : <>
                    <Container fluid>
                        <Row>
                            <Col xs="12">
                                <Card className="">
                                    <CardBody>
                                        <div className="float-end">
                                            <Button onClick={() => { this.setState({ redirectBack:true }) }} color="secondary" className='me-2'>
                                                <i className="uil-arrow-left me-2"></i>Kembali
                                            </Button>
                                        </div>
                                        <CardTitle>Daftar Tim {this.state.team?.ms360_team_work_unit_name} ({`Periode : ${moment(this.state.team.ms360_period_date_start).format('DD MMMM YYYY')} s/d ${moment(this.state.team.ms360_period_date_end).format('DD MMMM YYYY')}`}) </CardTitle>
                                        <CardSubtitle className="mb-3 w-full">
                                            <span className='d-block mb-4'>Ketua Tim : {this.state.team?.ms360_team_leader_name} {" "} {this.state.team?.employee_nip}</span>
                                            <div className='clearfix d-block mb-3'>
                                                <div className='float-start'>
                                                    <Button
                                                        onClick={() => this.handleFilter("all")}
                                                        color={this.state.filterData === 'all' ? "info" : "light"}
                                                        className="rounded-pill px-3 d-inline-flex align-items-center gap-2 btn-xs me-2"
                                                        >
                                                        Semua
                                                    </Button>
                                                    <Button
                                                        onClick={() => this.handleFilter("atasan")}
                                                        color={this.state.filterData === 'atasan' ? "info" : "light"}
                                                        className="rounded-pill px-3 d-inline-flex align-items-center gap-2 btn-xs me-2"
                                                        >
                                                        Atasan
                                                    </Button>
                                                    { parseInt(this.state?.team?.levels) > 2 ? <>
                                                    
                                                    <Button
                                                        onClick={() => this.handleFilter("sejawat")}
                                                        color={this.state.filterData === 'sejawat' ? "info" : "light"}
                                                        className="rounded-pill px-3 d-inline-flex align-items-center gap-2 btn-xs me-2"
                                                        >
                                                        Sejawat
                                                    </Button>

                                                    </> : <></> }
                                                    <Button
                                                        onClick={() => this.handleFilter("bawahan")}
                                                        color={this.state.filterData === 'bawahan' ? "info" : "light"}
                                                        className="rounded-pill px-3 d-inline-flex align-items-center gap-2 btn-xs"
                                                        >
                                                        Bawahan
                                                    </Button>
                                                </div>  
                                                <div className='float-end'>
                                                    <Button onClick={this.handleConfig} disabled={this.state.loadingConfig || !this.state.canGenerate} color="warning" className='me-2 text-white'>
                                                        { this.state.loadingConfig ? <>
                                                            <Spinner size="sm" className="me-1" />
                                                            Sedang memproses data, tunggu beberapa saat..
                                                        </> : <> <i className="uil uil-wrench me-2"></i>Konfigurasi Sampling 30 Peserta</> }
                                                    </Button>
                                                    <Button onClick={() => { this.setState({ modalGenerate:true, obj:null }) }} disabled={!this.state.canGenerate}  color="success" className='me-2'>
                                                        <i className="uil uil-setting me-2"></i>Generate Penilai Dinamis
                                                    </Button>     
                                                    <Button onClick={async () => { 
                                                        this.setState({ 
                                                            modalShow:true, 
                                                            obj:null,
                                                            messageUpload: "",
                                                            messageFailed: "Data gagal disimpan"
                                                        })
                                                        const params = {
                                                            employee_uuid: '',
                                                            work_unit_uuid: this.state.team?.ms360_team_work_unit_uuid,
                                                            relation: '',
                                                            team_uuid: this.state.team?.ms360_team_uuid
                                                        }
                                                        await this.teamBloc.fetchGroupMember(params)
                                                     }} color="primary" className='me-2'>
                                                        <i className="uil-plus me-2"></i>Tambah Data
                                                    </Button>
                                                     <Button onClick={() => { this.setState({ modalUpload:true, obj:null }) }} color="dark" className='me-2'>
                                                        <i className="uil uil-upload-alt me-2"></i>Import Data
                                                    </Button>
                                                    <Button color="info" disabled={this.state.loadingDownload} onClick={this.handleDownload}  type="button" className='me-2'>
                                                        { this.state.loadingDownload ? <>
                                                            <Spinner size="sm" className="me-1" />
                                                            Sedang Mendownload...
                                                        </> : <>  <i className="uil uil-download-alt me-2"></i>Download</> }
                                                    </Button> 
                                                    <Button color="danger" onClick={() => { this.setState({ modalConfirmDeleteAll: true, obj: null  }) }}  type="button" className='me-2'>
                                                        <i className="uil uil-trash-alt me-2"></i>Hapus Semua
                                                    </Button> 
                                                </div>
                                            </div>
                                        </CardSubtitle>
                                        <hr />
                                        <MKIDatatable
                                            className={this.configDatatable.tableClass}
                                            config={this.configDatatable}
                                            records={this.state.rows}
                                            columns={this.columns}
                                            dynamic={true}
                                            minWidth={1000}
                                            total_record={this.state.totalRow}
                                            initial={this.state.filter}
                                            onChange={(filter) => {
                                                this.setState({
                                                    loadingTable: true,
                                                    filter: filter
                                                }, function () {
                                                    this.setTokenAPI()
                                                });
                                            }}
                                            loading={this.state.loadingTable}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </> }
                <Modal isOpen={this.state.modalShow} size="lg" toggle={this.state.modalToggle}>
                    <AvForm className="needs-validation" onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}>
                        <ModalHeader toggle={this.state.modalToggle}>
                            { this.state.obj !== undefined && this.state.obj !== null && this.state.obj?.ms360_team_member_uuid !== '' ? <>
                                Edit Mapping Manual
                            </> : <>
                                Tambah Mapping Manual
                            </> }
                        </ModalHeader>
                        <ModalBody>
                            { this.state.obj !== undefined && this.state.obj !== null && this.state.obj?.ms360_team_member_uuid !== ''  ? <>
                            
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                   Penilai (Evaluator)  <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect 
                                        name={`evaluator_uuid`}
                                        errorMessage="Pilih Penilai (Evaluator)"
                                        options={this.state.members} 
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih Penilai (Evaluator)"
                                        isLoading={false}
                                        // defaultValue={this.state.obj?.ms360_team_member_evaluator_uuid ?? ""}
                                        defaultValue={(this.state.obj?.ms360_team_member_evaluator_uuid ?? "") || (this.state.evaluatorUuid ?? "")}
                                        //onChange={opt => this.setState({ evaluatorUuid: opt.value })}
                                        onChange={opt => this.handleChangeEvaluator(opt.value)}
                                    />   
                                </Col>
                            </Row>  
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                   Relasi Penilai  <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect 
                                        name={`relation`}
                                        errorMessage="Pilih Relasi Penilai"
                                        options={[
                                            { label: 'Atasan', value: 'atasan' },
                                            { label: 'Sejawat', value: 'sejawat' },
                                            { label: 'Bawahan', value: 'bawahan' }
                                        ]} 
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih Relasi Penilai"
                                        isLoading={false}
                                        defaultValue={this.state.obj?.ms360_team_member_relation ?? ""}
                                        onChange={opt => this.handleChangeMember(opt.value)}
                                    />   
                                </Col>
                            </Row>    
                            
                            </> : <></> }
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                  Unit Kerja (Evaluatee) <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect 
                                        name={`evalutaee_uuid`}
                                        errorMessage="Pilih Yang Dinilai (Evaluatee)"
                                        options={this.state.organizations} 
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih Yang Unit Kerja Dinilai (Evaluatee)"
                                        isLoading={this.state.organizationLoading}
                                        // defaultValue={this.state.obj?.ms360_team_member_evalutaee_uuid ?? ""}
                                        defaultValue={this.state.organizationUUid}
                                        onChange={opt => this.handleUnitKerja(opt.value)}
                                    />   
                                </Col>
                            </Row>              
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                   Yang Dinilai (Evaluatee) <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect 
                                        name={`evalutaee_uuid`}
                                        errorMessage="Pilih Yang Dinilai (Evaluatee)"
                                        options={this.state.evalutees} 
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih  Yang Dinilai (Evaluatee)"
                                        isLoading={this.state.loadingGroupMember}
                                        // defaultValue={this.state.obj?.ms360_team_member_evalutaee_uuid ?? ""}
                                        defaultValue={(this.state.obj?.ms360_team_member_evalutaee_uuid ?? "") || (this.state.evaluateeUuid ?? "")}
                                        onChange={opt => this.handleChangeEvaluatee(opt.value)}
                                    />   
                                </Col>
                            </Row>       
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => { this.setState({ modalShow: false }) }}>
                                Batal
                            </Button>{" "}
                            <Button color="primary" type="submit">
                                 { this.state.obj !== undefined && this.state.obj !== null ? <>
                                    Update
                                </> : <>
                                    Simpan
                                </> }
                            </Button>           
                        </ModalFooter>
                    </AvForm>                 
                </Modal>
                <Modal isOpen={this.state.modalGenerate} size="md" toggle={this.state.modalGenerate}>
                    <ModalHeader toggle={this.state.modalGenerate}>
                        <i className="uil uil-setting me-2"></i>Generate Auto-Mapping Dinamis?
                    </ModalHeader>   
                    <ModalBody>
                        <p className='text-muted'>
                            Sistem akan memetakan relasi Penilai (Atasan, Sejawat, Bawahan) secara dinamis berdasarkan Jenis Jabatan & Tim Kerja. Data yang ada tidak akan ditimpa.
                        </p>
                        { parseFloat(this.state.percentageStatus) > 0 ? <>
                        
                            <div className="progress">
                                <div
                                    className="progress-bar progress-bar-striped progress-bar-animated"
                                    role="progressbar"
                                    style={{
                                    width: `${this.state.percentageStatus}%`,
                                    transition: "width 0.05s linear",
                                    }}
                                    aria-valuenow={this.state.percentageStatus}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                >
                                    {this.state.percentageStatus}%
                                </div>
                            </div>
                        
                        </> : <></> }
                       
                    </ModalBody> 
                    <ModalFooter>
                        <Button color="secondary" disabled={this.state.loadingGenerate} onClick={() => { this.setState({ modalGenerate: false }) }}>
                            Batal
                        </Button>{" "}
                        <Button color="primary" disabled={this.state.loadingGenerate} onClick={this.handleGenerate}  type="button">
                           { this.state.loadingGenerate ? <>
                                <Spinner size="sm" className="me-1" />
                                Sedang Generate Data...
                           </> : <> Generate Sekarang</> }
                        </Button>           
                    </ModalFooter>              
                </Modal>
                <Modal isOpen={this.state.modalConfirmDeleteAll} size="md" toggle={this.state.modalConfirmDeleteAll}>
                    <ModalHeader toggle={this.state.modalConfirmDeleteAll}>
                        <i className="uil uil-trash-alt me-2"></i>Hapus Semua Data
                    </ModalHeader>   
                    <ModalBody>
                       <div class="alert alert-danger">
                            <strong>⚠️ Peringatan!</strong>
                            <p className='fw-bold'>Semua data akan dihapus secara permanen dan tindakan ini tidak dapat dibatalkan.</p>
                        </div>
                    </ModalBody> 
                    <ModalFooter>
                        <Button color="secondary" disabled={this.state.loadingDeleteAll} onClick={() => { this.setState({ modalConfirmDeleteAll: false }) }}>
                            Batal
                        </Button>{" "}
                        <Button color="primary" disabled={this.state.loadingDeleteAll} onClick={this.handleResetAll}  type="button">
                           { this.state.loadingDeleteAll ? <>
                                <Spinner size="sm" className="me-1" />
                                Sedang Menghapus Data...
                           </> : <> Hapus Semua Sekarang</> }
                        </Button>           
                    </ModalFooter>              
                </Modal>
                <Modal isOpen={this.state.modalConfig} size="xl" toggle={this.state.modalConfig}>
                    <ModalHeader toggle={this.state.modalConfig}>
                        <i className="uil uil-wrench me-2"></i>Konfigurasi Sampling 30
                    </ModalHeader>   
                    <ModalBody>

                        <div className="d-flex align-items-start mb-4">
                            <span
                            className="d-flex align-items-center justify-content-center rounded me-3 flex-shrink-0"
                            style={{
                                width: 40,
                                height: 40,
                                backgroundColor: "#e0e3fd",
                                color: "#4f46e5",
                            }}
                            >
                            <FeatherIcon icon="settings" size={20} />
                            </span>
                            <p className="text-secondary mb-0 pt-1">
                            Atur prioritas penilai wajib (Ahli Madya, Kabag, Ahli Muda,
                            Kasubbag) dan persentase random sampling untuk staf di setiap
                            Tim Kerja / Pokja.
                            </p>
                        </div>

                        {/* Section 1: Mandatory evaluators */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: "#eef0fe" }}>
                            <CardBody className="p-4">
                            <div className="d-flex align-items-center mb-2">
                                <FeatherIcon
                                icon="check-circle"
                                size={18}
                                className="text-primary me-2 flex-shrink-0"
                                />
                                <h2
                                className="h6 fw-bold text-indigo mb-0"
                                style={{ color: "#3730a3", letterSpacing: "0.02em" }}
                                >
                                1. PRIORITAS PENILAI WAJIB (MANDATORY EVALUATORS)
                                </h2>
                            </div>
                            <p className="small text-primary-emphasis ps-4 mb-3">
                                Kelompok penilai di bawah ini <strong>WAJIB 100%</strong>{" "}
                                dipetakan sebagai Bawahan saat menilai Atasan (JPT Pratama /
                                Direktur):
                            </p>

                            <div className="ps-4 d-flex flex-column gap-2">
                                <Card className="border shadow-sm">
                                <CardBody className="py-2 px-3">
                                    <FormGroup check className="d-flex align-items-center mb-0">
                                    <Input
                                        type="checkbox"
                                        id="ahliMadya"
                                        checked={this.state.configForm.ms360_team_priority_ahli_madya === 1}
                                        onChange={() => this.toggleMandatory("ahliMadya")}
                                        className="me-2"
                                        style={{ width: 18, height: 18 }}
                                    />
                                    <Label check for="ahliMadya" className="mb-0 text-dark">
                                        <strong>Ahli Madya &amp; Kepala Bagian (Kabag)</strong>{" "}
                                        — Level 4 Non-JPT{" "}
                                        <span className="text-primary fw-medium">
                                        (Wajib 100%)
                                        </span>
                                    </Label>
                                    </FormGroup>
                                </CardBody>
                                </Card>

                                <Card className="border shadow-sm">
                                <CardBody className="py-2 px-3">
                                    <FormGroup check className="d-flex align-items-center mb-0">
                                    <Input
                                        type="checkbox"
                                        id="ahliMuda"
                                        checked={this.state.configForm.ms360_team_priority_ahli_muda === 1}
                                        onChange={() => this.toggleMandatory("ahliMuda")}
                                        className="me-2"
                                        style={{ width: 18, height: 18 }}
                                    />
                                    <Label check for="ahliMuda" className="mb-0 text-dark">
                                        <strong>
                                        Ahli Muda &amp; Kepala Subbagian (Kasubbag)
                                        </strong>{" "}
                                        — Level 3{" "}
                                        <span className="text-primary fw-medium">
                                        (Wajib 100%)
                                        </span>
                                    </Label>
                                    </FormGroup>
                                </CardBody>
                                </Card>
                            </div>
                            </CardBody>
                        </Card>

                        {/* Section 2: Sampling */}
                        <Card className="mb-4">
                            <CardBody className="p-4">
                            <div className="d-flex align-items-center mb-3">
                                <FeatherIcon
                                icon="zap"
                                size={18}
                                className="text-warning me-2 flex-shrink-0"
                                />
                                <h2 className="h6 fw-bold text-dark mb-0">
                                2. PERSENTASE RANDOM SAMPLING SISA PEGAWAI TIM KERJA (%)
                                </h2>
                            </div>

                            {/* Warning box */}
                            <Alert color="warning" className="d-flex mb-4">
                                <FeatherIcon
                                icon="info"
                                size={18}
                                className="me-2 flex-shrink-0 mt-1"
                                />
                                <div className="small">
                                <p className="fw-bold mb-1">
                                    Aturan Ambang Batas Unit Kerja (≤ {UNIT_THRESHOLD}{" "}
                                    Pegawai):
                                </p>
                                <ul className="mb-0 ps-3">
                                    <li>
                                    Untuk unit kerja dengan total ≤ {UNIT_THRESHOLD}{" "}
                                    pegawai, persentase sampling{" "}
                                    <strong>TIDAK BERLAKU</strong> (100% seluruh level
                                    pegawai menilai pimpinan).
                                    </li>
                                    <li>
                                    Persentase random sampling acak di bawah ini hanya
                                    aktif untuk unit kerja besar dengan{" "}
                                    <strong>&gt; {UNIT_THRESHOLD} pegawai</strong>.
                                    </li>
                                </ul>
                                </div>
                            </Alert>

                            {/* Sampling inputs */}
                            <Row className="g-3">
                                <Col xs={12} sm={6}>
                                <Card className="h-100">
                                    <CardBody>
                                    <p className="fw-bold small text-dark mb-1">
                                        Sampling Rekan Sejawat Tim (%)
                                    </p>
                                    <p className="text-muted mb-3" style={{ fontSize: "0.8rem" }}>
                                        Persentase sampling acak untuk penilaian Sejawat di
                                        level setara.
                                    </p>
                                    <InputGroup style={{ maxWidth: 220 }}>
                                        <Input
                                        type="number"
                                        min={0}
                                        max={100}
                                        value={this.state.configForm.ms360_team_sampling_sejawat ?? 30}
                                        onChange={this.handlePeerChange}
                                        />
                                        <InputGroupText>% Populasi Tim</InputGroupText>
                                    </InputGroup>
                                    </CardBody>
                                </Card>
                                </Col>

                                <Col xs={12} sm={6}>
                                <Card className="h-100">
                                    <CardBody>
                                    <p className="fw-bold small text-dark mb-1">
                                        Sampling Staff Junior / Pelaksana (%)
                                    </p>
                                    <p className="text-muted mb-3" style={{ fontSize: "0.8rem" }}>
                                        Persentase sampling acak untuk staff pelaksana /
                                        junior.
                                    </p>
                                    <InputGroup style={{ maxWidth: 220 }}>
                                        <Input
                                        type="number"
                                        min={0}
                                        max={100}
                                        value={this.state.configForm.ms360_team_sampling_junior ?? 20}
                                        onChange={this.handleJuniorChange}
                                        />
                                        <InputGroupText>% Populasi Tim</InputGroupText>
                                    </InputGroup>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                            </CardBody>
                        </Card>

                        { groups.length > 0 ? <>
                        {/* Matrix table */}
                        <Card>
                            <CardHeader className="bg-light">
                            <h2 className="h6 fw-bold text-dark mb-0">
                                MATRIKS ACUAN RUMPUN JABATAN TIM KERJA
                            </h2>
                            </CardHeader>
                            <CardBody className="p-0">
                                <Table responsive className="mb-0 align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Kelompok Jabatan (Yang Dinilai)</th>
                                            <th className='text-center'>Atasan</th>
                                            <th className='text-center'>Sejawat ({this.state.configForm.ms360_team_sampling_sejawat}%)</th>
                                            <th className='text-center'>Bawahan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {groups.map((row, i) => (
                                        <tr key={i}>
                                            <td className="fw-medium">{row.label}</td>
                                            { parseInt(this.state.configForm.ms360_team_priority_ahli_madya) === 0 && parseInt(this.state.configForm.ms360_team_priority_ahli_muda) === 0  ? <>
                                                <td className="text-secondary">{row.atasan}</td>
                                                <td className="text-secondary">{row.sejawat}</td>
                                                <td className="text-secondary">{row.bawahan}</td>
                                            </> : <></> }
                                            { parseInt(this.state.configForm.ms360_team_priority_ahli_madya) === 0 && parseInt(this.state.configForm.ms360_team_priority_ahli_muda) === 1  ? <>
                                                <td className="text-secondary">{row.atasan}</td>
                                                <td className="text-secondary">{row.sejawat}</td>
                                                <td className="text-secondary">
                                                    { i === 0 || i === 1 ? <>
                                                        <strong>Ahli Muda & Kasubbag (Wajib), + Staff ({this.state.configForm.ms360_team_sampling_junior}% Sampling)</strong>
                                                    </> : <>
                                                       <strong> {row.bawahan}</strong>
                                                    </> }
                                                </td>
                                            </> : <></> }
                                            { parseInt(this.state.configForm.ms360_team_priority_ahli_madya) === 1 && parseInt(this.state.configForm.ms360_team_priority_ahli_muda) === 0  ? <>
                                                <td className="text-secondary">
                                                    {row.atasan}
                                                </td>
                                                <td className="text-secondary">{row.sejawat}</td>
                                                <td className="text-secondary">
                                                    { i === 0 ? <>
                                                        <strong>Ahli Madya & Kabag (Wajib), + Staff ({this.state.configForm.ms360_team_sampling_junior}% Sampling)</strong>
                                                    </> : <>
                                                       <strong> {row.bawahan}</strong>
                                                    </> }
                                                </td>
                                            </> : <></> }
                                            { parseInt(this.state.configForm.ms360_team_priority_ahli_madya) === 1 && parseInt(this.state.configForm.ms360_team_priority_ahli_muda) === 1  ? <>
                                                <td className="text-secondary">{row.atasan}</td>
                                                <td className="text-secondary">{row.sejawat}</td>
                                                <td className="text-secondary">
                                                     { i === 0 ? <>
                                                        <strong>
                                                            Ahli Madya & Kabag (Wajib), Ahli Muda & Kasubbag (Wajib), + Staff ({this.state.configForm.ms360_team_sampling_junior}% Sampling)
                                                        </strong>
                                                    </> : <>
                                                       { i === 1 ? <>
                                                            <strong>
                                                                Ahli Muda & Kasubbag (Wajib), + Staff ({this.state.configForm.ms360_team_sampling_junior}% Sampling)
                                                            </strong>
                                                       </> : <>
                                                            <strong> {row.bawahan}</strong>
                                                        </> }
                                                    </> }
                                                </td>
                                            </> : <></> }
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                        </> : <></> }

                      
                    </ModalBody> 
                    <ModalFooter>
                        <Button color="secondary" disabled={this.state.loadingConfig} onClick={() => { this.setState({ modalConfig: false }) }}>
                            Batal
                        </Button>{" "}
                        <Button color="primary" disabled={this.state.loadingConfig} onClick={this.handleConfig}  type="button">
                           { this.state.loadingConfig ? <>
                                <Spinner size="sm" className="me-1" />
                                Sedang Menyimpan Konfigurasi...
                           </> : <> Simpan Konfigurasi</> }
                        </Button>           
                    </ModalFooter>              
                </Modal>
                <Modal isOpen={this.state.modalUpload} size="xl" toggle={this.state.modalUpload}>
                    <ModalHeader>
                        <h3>
                            <small><i className="uil-upload me-2"></i>Import Excel</small>
                        </h3>
                    </ModalHeader>     
                    <ModalBody>
                        <Row className="mb-3">
                            <label className="col-md-3 col-form-label">
                                File Excel <span className="text-danger">*</span>
                            </label>
                            <Col md="9">
                                <div className="input-group mb-4">
                                    <input
                                        ref={this.fileInputRef}
                                        type="file"
                                        className="form-control"
                                        accept=".xlsx,.xls"
                                        onChange={this.handleExcelFileChange}
                                    />
                                </div>
                                    { this.state.loadingUpload ? <>
                                    <div className=''>
                                        <Spinner size="sm" className="me-1" />
                                            Memproses...
                                    </div>
                                </> : <></> }
                                { this.state.messageUpload ? <>
                                    <p className="bg-danger mt-2 mb-2 p-2 text-white">
                                        {this.state.messageUpload}
                                    </p>
                                </> : <></> }
                            </Col>
                        </Row>
                         <Row className="mb-3">
                             <Col md="12">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th className='text-center'>No</th>
                                            <th>Penilai (Evaluator)</th>
                                            <th>Yang Dinilai (Evaluatee)</th>
                                            <th className='text-center'>Relasi Penilai </th>
                                            <th>Keterangan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { this.state.loadingBulk ? <>
                                             <tr>
                                                <td colSpan={5} className='text-center'>
                                                    <Spinner size="sm" className="me-1" />
                                                    Sistem sedang memvalidasi, mohon tunggu beberapa saat...
                                                </td>
                                            </tr>
                                        </> : <>
                                            { this.state.bulkInsert.length === 0 ? <>
                                            <tr>
                                                <td colSpan={5} className='text-center'>
                                                    -- Tidak Ada Data --
                                                </td>
                                            </tr>
                                        </> : <>
                                            { this.state.bulkInsert.map((record, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className='text-center'>{index+1}</td>
                                                        <td>
                                                            <span className='d-block'>
                                                                <strong>
                                                                    <small>{record?.evaluator?.employee_nip} - {record?.evaluator?.employee_name}</small>
                                                                </strong>
                                                            </span>
                                                            <p className='d-block'>
                                                                {record?.evaluator?.work_unit_name}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <span className='d-block'>
                                                                <strong>
                                                                    <small>{record?.evaluatee?.employee_nip} - {record?.evaluatee?.employee_name}</small>
                                                                </strong>
                                                            </span>
                                                            <p className='d-block'>
                                                                {record?.evaluatee?.work_unit_name}
                                                            </p>
                                                        </td>
                                                        <td className='text-center'>{record?.relation}</td>
                                                        <td>
                                                            {  record?.status?.can_import === true ? <>
                                                                <span className="badge bg-success">
                                                                    <i className="uil uil-check-circle me-1"></i>{'Ok'}
                                                                </span>
                                                            </> : <>
                                                                <small className='text-danger'>{record?.status?.message}</small>
                                                            </> }     
                                                        </td>
                                                    </tr>
                                                    )
                                                }) }
                                            </> }
                                        </> }
                                    </tbody>
                                </table>
                             </Col>
                         </Row>
                    </ModalBody> 
                    <ModalFooter>
                        <Button color="secondary" disabled={this.state.loadingUpload} onClick={() => { this.setState({ modalUpload: false }) }}>
                            <i className="uil uil-times-circle me-2"></i>Batal
                        </Button>{" "}
                         <Button color="success" disabled={this.state.loadingUpload} onClick={this.templateUpload}>
                            <i className="uil-file me-2"></i>Template Upload
                        </Button>{" "}
                        { this.state.can_import ? <>
                            <Button color="primary" disabled={this.state.loadingUpload} onClick={this.doImport}>
                                { this.state.loadingUpload ? <>
                                    <Spinner size="sm" className="me-1" />
                                    Sedang Mengimport...
                                </> : <> <i className="uil-upload me-2"></i>Import Data</> }
                            </Button>   
                        </> : <></> }        
                    </ModalFooter>                
                </Modal>
                { this.state.redirectBack ?
                    <Redirect to={"/master/timkerja360.html?section=team&uuid=" + this.state.team?.ms360_team_period_uuid}/>
                : null }
                    <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={this.state.inactiveUuid ? 'Apakah anda yakin hapus data' : "Apakah anda yakin data tersebut sudah benar?"}
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo={'Data berhasil diperbaharui'}
                    failedTitle="Gagal!"
                    failedInfo={this.state.messageFailed}
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }

}

export default MemberComponent